import React from "react";
import Navbar from "../layout/Navbar";
import strategic_image from "../assests/Images/Strategic_main_Image.jpg";
import strategic_Img from "../assests/Images/stratrgic_img_1.png";
import { RiDoubleQuotesL } from "react-icons/ri";
import PPP from "../assests/Images/PPP.png";
import { GiProgression } from "react-icons/gi";
import { MdPeopleAlt } from "react-icons/md";
import sourcing from "../assests/Images/strategy_sourcing.png";
import leadership from "../assests/Images/LeaderShip.png";
import { FaArrowRight } from "react-icons/fa6";
import employe_engagement from "../assests/Images/Employee_eng.jpg";
import performance_management from "../assests/Images/Performance.jpg";
import Footer from "../layout/Footer";
import hr_policies from "../assests/Images/HR_Policies.png";
import total_rewards from "../assests/Images/Rewards.png";
import { useInView } from "react-intersection-observer";
import WaveEffect from "../Components/WaveEffect";
import { GiFlatStar } from "react-icons/gi";

const Strategic = () => {
  const { ref: ref1, inView: inView1 } = useInView({
    triggerOnce: false,
    threshold: 0,
  });
  const { ref: ref2, inView: inView2 } = useInView({
    triggerOnce: false,
    threshold: 0,
  });

  return (
    <>
      <Navbar />
      <section
        className="bg-cover bg-center h-[75vh] lg:h-[75vh] md:h-[500px] sm:h-[400px] "
        style={{ backgroundImage: `url(${strategic_image})` }}
      >
        <div className="h-full bg-black bg-opacity-60 flex flex-col gap-6 items-center justify-center ">
          <WaveEffect
            text="Strategic HR"
            textClassName="text-white text-4xl lg:text-8xl md:text-7xl sm:text-6xl text-center font-bold"
          />
          <p className=" text-base text-white text-center md:text-xl sm-text-lg mt-3">
            Strategies the help you enhance your way of working!
          </p>
        </div>
      </section>

      <section className="mt-10 space-y-10  p-5 lg:px-20 lg:py-10 grid xl:grid-cols-2 lg:grid-cols-2  gap-5 lg:gap-16  ">
        <div className="flex justify-center items-center">
          <img src={strategic_Img} alt="" />
        </div>

        <div ref={ref1} className="flex flex-col gap-5 ">
          <h1 className=" bg-red-100 font-bold text-red-700 w-fit rounded-3xl text-sm px-4 py-2">
            HR IN A BOX
          </h1>
          <h1 className="text-4xl font-bold  text-gray-900 leading-tight">
            Your Trusted Human Resource
            <span className="text-red-600"> Business Partner</span>
          </h1>
          <p className="lg:text-base line xl:text-base/7">
            Human resources are the bedrock of any organization’s growth and
            profitability. To maximize employee potential and performance, a
            well-crafted long-term strategy is essential. As your trusted
            partner, we help establish a world-class HR function, positioning
            your organization as a preferred employer with a high-performing,
            loyal workforce committed to growth and profitability.
          </p>
          <div className="flex flex-col  lg:flex-col xl:flex-col md:flex-col sm:flex-col gap-2  ">
            <RiDoubleQuotesL className="text-primary size-10 lg:size-14 xl:size-20 md:size-14 sm:size-14" />
            <p className="text-xl">Our Three-Dimensional Approach:</p>
            <h1 className="text-primary font-medium">
              People, Process, Progress
            </h1>
          </div>
        </div>
      </section>

      <div className="flex justify-center items-center">
        <img src={PPP} alt="" />
      </div>

      <section ref={ref2} className="xl:mx-20 lg:m-14 md:m-7 sm:mx-5">
        {inView2 && (
          <WaveEffect
            text="Employee Engagement And Experience"
            textClassName="text-center text-2xl xl:text-4xl lg:text-2xl  md:text-2xl  font-semibold"
          />
        )}
        <p className="mt-5 text-lg/7 text-center">
          In a rapidly changing world, how employees experience work is more
          critical than ever. Effective engagement fosters loyalty, reduces
          attrition, and boosts productivity. Our interventions enhance
          engagement, morale, and a sense of belonging through:
        </p>
        <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-3  justify-center items-center max-w-5xl mx-auto gap-6 py-10 px-4 text-center ">
          <div className="bg-blue-100 p-10 flex flex-col justify-center items-center">
            <svg
              className="size-16  duration-1000 hover:scale-125 text-primary"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              stroke="#b22222"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <path
                  d="M12.1992 12C14.9606 12 17.1992 9.76142 17.1992 7C17.1992 4.23858 14.9606 2 12.1992 2C9.43779 2 7.19922 4.23858 7.19922 7C7.19922 9.76142 9.43779 12 12.1992 12Z"
                  stroke="#b22222"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>{" "}
                <path
                  d="M21.5902 16.35L16.5002 21.44C15.9902 21.94 14.5002 22.1799 14.1502 21.8399C14.0173 21.4468 13.9851 21.0265 14.0567 20.6177C14.1284 20.2088 14.3015 19.8246 14.5602 19.5L19.6502 14.4C19.915 14.1767 20.254 14.0613 20.6001 14.0764C20.9461 14.0915 21.2738 14.2361 21.518 14.4817C21.7623 14.7272 21.9053 15.0557 21.9187 15.4018C21.932 15.7479 21.8148 16.0863 21.5902 16.35V16.35Z"
                  stroke="#b22222"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>{" "}
                <path
                  d="M3 22C3.57038 20.0332 4.74795 18.2971 6.36438 17.0399C7.98081 15.7827 9.95335 15.0687 12 15"
                  stroke="#b22222"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>{" "}
              </g>
            </svg>
            <h1 className="mt-2 xl:text-2xl font-semibold">Process</h1>
          </div>

          <div className="bg-blue-100 p-10 flex flex-col justify-center items-center">
            <GiProgression className="size-16  duration-1000 hover:scale-125 text-primary" />
            <h1 className="mt-2 xl:text-2xl font-semibold">Policy</h1>
          </div>

          <div className="bg-blue-100 p-10 flex flex-col justify-center items-center">
            <MdPeopleAlt className="size-16  duration-1000 hover:scale-125 text-primary" />
            <h1 className="mt-2 xl:text-2xl font-semibold">Leadership</h1>
          </div>
        </div>
      </section>

      <section className=" mx-5  lg:m-14 mb-0 md:m-7 sm:mx-5 ">
        <h1 className="  text-2xl text-center xl:text-4xl lg:text-2xl md:text-2xl font-semibold">
          Talent Mapping and Deployment
        </h1>
        <div className="flex flex-col gap-10 xl:flex-row lg:flex-row ">
          <div className="flex flex-col justify-center items-start gap-3  h-[300px] mt-14 lg:mt-2 md:mt-2 sm:mt-3 xl:mt-14">
            <p className="mt-5 text-lg/7 ">
              Align talent management with strategic workforce planning to
              balance high-performance and high-potential talent with your
              organization’s evolving needs.
            </p>
            <div className="group flex flex-row justify-start items-center gap-2">
              <GiProgression className="size-14 group-hover:text-primary" />
              <p className="text-lg">
                Assess high-potential and high-performing individuals
              </p>
            </div>
            <hr className="border-t border-primary w-full " />

            <div className=" group flex flex-row justify-start items-center gap-2">
              <svg
                className="size-14 group-hover:text-primary fill-current"
                viewBox="0 0 52 52"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <circle cx="16.35" cy="20.81" r="7.21"></circle>
                  <path d="M16.35,29.62h-.17A10.76,10.76,0,0,0,5.85,40.5v2.58a1.29,1.29,0,0,0,1.29,1.29H25.6a1.27,1.27,0,0,0,1.26-1.25v-3A10.51,10.51,0,0,0,16.35,29.62Z"></path>
                  <path d="M31.34,27.77l-4.12,4.39a13.4,13.4,0,0,1,2.62,8v3a4.42,4.42,0,0,1-.21,1.25h.13a18.28,18.28,0,0,0,12.44-4.9L31.36,27.77Z"></path>
                  <path d="M41.12,11.54A18.36,18.36,0,0,0,19.19,11a10.2,10.2,0,0,1,3.94,17.44,14.64,14.64,0,0,1,2.08,1.5l4.67-5V17.29a1.5,1.5,0,0,1,1.5-1.5h6.09a1.5,1.5,0,0,1,1.5,1.5v4.19a1.5,1.5,0,0,1-1.5,1.5H32.88v2L44.24,37.3A18.35,18.35,0,0,0,41.12,11.54Z"></path>
                </g>
              </svg>
              <p className="text-lg">Groom talent for future roles</p>
            </div>
            <hr className="border-t border-primary w-full " />

            <div className="group flex flex-row justify-start items-center gap-2">
              <svg
                className="size-14 group-hover:text-primary fill-current"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path d="M6.108,20H4a1,1,0,0,0,0,2H20a1,1,0,0,0,0-2H17.892c-.247-2.774-1.071-7.61-3.826-9,2.564-1.423,3.453-4.81,3.764-7H20a1,1,0,0,0,0-2H4A1,1,0,0,0,4,4H6.17c.311,2.19,1.2,5.577,3.764,7C7.179,12.39,6.355,17.226,6.108,20ZM9,16.6c0-1.2,3-3.6,3-3.6s3,2.4,3,3.6V20H9Z"></path>
                </g>
              </svg>
              <p className="text-lg">Implement succession planning</p>
            </div>
          </div>

          <div>
            <img src={sourcing} alt="" className="" />
          </div>
        </div>
      </section>

      <section className="mx-4 mt-0 lg:mx-14 h-[85%]">
        <div className="grid lg:grid-cols-2 xl:grid-cols-2 xl:px-5 p-3 lg:gap-10">
          <div className="w-[100%] hidden md:flex xl:w-[90%]  lg:w-[100%] sm:w-[100%] md:w-[100%]  justify-center items-center">
            <img
              src={leadership}
              alt=""
              className="xl:h-[100%] lg:h-[100%]  "
            />
          </div>

          <div className="w-[100%] flex flex-col  space-y-4">
            <h1 className=" text-start text-2xl  xl:text-4xl lg:text-2xl md:text-2xl font-semibold">
              Leadership Development
            </h1>
            <p className="text-base/7">
              Strong, effective leadership is the cornerstone of both individual
              and organizational success. Our leadership development programs
              elevate morale, loyalty, and profitability by integrating
              leadership skills into your operations, preparing employees for
              challenging roles and responsibilities.
            </p>
            <div className="group flex flex-row justify-start items-center gap-2">
              <FaArrowRight className="size-5 group-hover:text-primary" />
              <p>Develop leadership at every level (Leading with Impact)</p>
            </div>
            <hr className="border-t border-primary w-full " />

            <div className="group flex flex-row justify-start items-center gap-2">
              <FaArrowRight className="size-5 group-hover:text-primary" />
              <p>Create a talent pipeline and remove bottlenecks</p>
            </div>
            <hr className="border-t border-primary w-full " />

            <div className="group flex flex-row justify-start items-center gap-2">
              <FaArrowRight className="size-5 group-hover:text-primary" />
              <p>Conduct talent reviews and develop succession roadmaps</p>
            </div>
          </div>
        </div>
      </section>

      <section className=" mx-4 xl:my-10 lg:mx-5">
        <div className="grid lg:grid-cols-2 xl:grid-cols-2 xl:px-10 p-3 lg:gap-10">
          <div className="w-[100%] flex flex-col  space-y-4">
            <h1 className=" text-start text-2xl  xl:text-4xl lg:text-2xl md:text-2xl font-semibold">
              Employee Engagement and Experience
            </h1>
            <p className="text-base/7">
              In a rapidly changing world, how employees experience work is more
              critical than ever. Effective engagement fosters loyalty, reduces
              attrition, and boosts productivity. Our interventions are designed
              to enhance engagement, morale, and a sense of belonging.
            </p>
            <div className="group flex flex-row justify-start items-center gap-2">
              <FaArrowRight className="size-5 group-hover:text-primary" />
              <p>Innovative feedback systems</p>
            </div>
            <hr className="border-t border-primary w-full " />

            <div className="group flex flex-row justify-start items-center gap-2">
              <FaArrowRight className="size-5 group-hover:text-primary" />
              <p>Linking engagement to business outcomes</p>
            </div>
            <hr className="border-t border-primary w-full " />

            <div className="group flex flex-row justify-start items-center gap-2">
              <FaArrowRight className="size-5 group-hover:text-primary" />
              <p>Revamping talent engagement strategies</p>
            </div>
          </div>

          <div className="w-[100%] xl:w-[90%]  lg:w-[100%] sm:w-[100%] md:w-[100%] flex justify-center items-center">
            <img
              src={employe_engagement}
              alt=""
              className="xl:h-[100%] lg:h-[100%] "
            />
          </div>
        </div>
      </section>

      <section className="mx-4 xl:my-10 lg:mx-5 ">
        <div className="grid lg:grid-cols-2 xl:grid-cols-2 xl:px-10 p-3 lg:gap-10">
          <div className="w-[100%] xl:w-[90%]  lg:w-[100%] sm:w-[100%] md:w-[100%] hidden md:flex justify-center items-center">
            <img
              src={performance_management}
              alt=""
              className="xl:h-[100%] lg:h-[100%] "
            />
          </div>
          <div className="w-[100%] flex flex-col  space-y-4">
            <h1 className=" text-start text-2xl  xl:text-4xl lg:text-2xl md:text-2xl font-semibold">
              Performance Management
            </h1>
            <p className="text-base/7">
              Performance management is a continuous process that supports your
              organization’s strategic objectives. It fosters an environment
              where employees can perform at their best, driving a culture of
              openness and results orientation.
            </p>
            <div className="group flex flex-row justify-start items-center gap-2">
              <FaArrowRight className="size-5 group-hover:text-primary" />
              <p>
                Institutionalize a performance management system aligned with
                business objectives and core values
              </p>
            </div>
            <hr className="border-t border-primary w-full " />

            <div className="group flex flex-row justify-start items-center gap-2">
              <FaArrowRight className="size-5 group-hover:text-primary" />
              <p>Enhance individual contributions and drive results</p>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-4 xl:my-20 lg:mx-5 ">
        <div className="grid lg:grid-cols-2 xl:grid-cols-2 xl:px-10 p-3 lg:gap-10">
          <div className="w-[100%] flex flex-col  space-y-4">
            <h1 className=" text-start text-2xl  xl:text-4xl lg:text-2xl md:text-2xl font-semibold">
              HR Policies And Manuals
            </h1>
            <p className="text-base/7">
              Transition your organization from being personality-driven to
              policy-driven, sustaining excellence and growth. Our comprehensive
              HR manuals provide strategies for effective administration,
              ensuring alignment across all levels of the organization.
            </p>
            <div className="group flex flex-row justify-start items-center gap-2">
              <FaArrowRight className="size-5 group-hover:text-primary" />
              <p>Design and implement policies</p>
            </div>
            <hr className="border-t border-primary w-full " />

            <div className="group flex flex-row justify-start items-center gap-2">
              <FaArrowRight className="size-5 group-hover:text-primary" />
              <p>Develop a RASCI framework</p>
            </div>
            <hr className="border-t border-primary w-full " />

            <div className="group flex flex-row justify-start items-center gap-2">
              <FaArrowRight className="size-5 group-hover:text-primary" />
              <p>Ensure effective policy implementation</p>
            </div>
          </div>

          <div className="w-[100%] xl:w-[90%] lg:w-[100%] sm:w-[100%] md:w-[100%] flex justify-center items-center">
            <img
              src={hr_policies}
              alt=""
              className="xl:h-[100%] lg:h-[100%] "
            />
          </div>
        </div>
      </section>

      <section className="mx-4 xl:my-20 lg:mx-5 ">
        <div className="grid lg:grid-cols-2 xl:grid-cols-2 xl:px-10 p-3 lg:gap-10">
          <div className="w-[100%] xl:w-[90%] lg:w-[100%] sm:w-[100%] md:w-[100%] hidden md:flex  justify-center items-center">
            <img
              src={total_rewards}
              alt=""
              className="xl:h-[100%] lg:h-[100%] "
            />
          </div>

          <div className="w-[100%] flex flex-col  space-y-4">
            <h1 className=" text-start text-2xl  xl:text-4xl lg:text-2xl md:text-2xl font-semibold">
              Total Rewards And Recognition
            </h1>
            <p className="text-base/7">
              Retain top talent by offering ample opportunities for progression
              alongside a robust rewards and recognition system. Our holistic
              approach covers the entire employee lifecycle, from onboarding to
              ongoing development, fostering loyalty, reducing attrition, and
              enhancing team performance.
            </p>
            <div className="group flex flex-row justify-start items-center gap-2">
              <FaArrowRight className="size-5 group-hover:text-primary" />
              <p>Design comprehensive rewards and recognition systems</p>
            </div>
            <hr className="border-t border-primary w-full " />

            <div className="group flex flex-row justify-start items-center gap-2">
              <FaArrowRight className="size-5 group-hover:text-primary" />
              <p>Promote a high-performance culture</p>
            </div>

            <div className="group flex flex-row justify-start items-center gap-2">
              <p className="text-base/7">
                Partner with us to transform your HR function into a strategic
                asset that drives growth, engagement, and performance across
                your organization.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Strategic;
